<script setup lang="ts">
/* Utils */
import { Field as VeeField, defineRule } from 'vee-validate'
import { maxNoteLength } from '@/utils/rulesOfValidate'
/* Stores */
import { useBasketStore } from '~/store/basket/basket'
/* Components */
import BasketTitle from '~/components/Basket/basket-utils/BasketTitle.vue'
import BasketErrorMessage from '~/components/Basket/basket-utils/BasketErrorMessage.vue'

const MAX_NOTE_LENGTH_RULE = 'maxNoteLength'

const { isMobile } = useDevice()
const basketStore = useBasketStore()

const note = computed({
  get() {
    return basketStore.data.note
  },
  set(value: string) {
    basketStore.setNote(value)
  },
})

defineRule(MAX_NOTE_LENGTH_RULE, maxNoteLength)
</script>

<template>
  <section id="note">
    <vee-field
      v-slot="{ errors, field }"
      v-model="note"
      name="note"
      vid="note"
      :rules="MAX_NOTE_LENGTH_RULE"
      immediate
    >
      <basket-title title="Комментарий кухне" />

      <v-textarea
        v-bind="field"
        :rows="isMobile ? 2 : 6"
        :no-resize="true"
        :model-value="note"
        variant="solo"
        class="note__item"
        color="black"
        counter="300"
        maxlength="300"
        placeholder="Здесь можно написать пояснения или пожелания к заказу"
      />

      <basket-error-message
        v-if="errors.length !== 0"
        :error-message="errors[0]"
      />
    </vee-field>

    <div id="basket-note-observable-target" class="basket-observable-target" />
  </section>
</template>

<style lang="scss" scoped>
.note {
  &__item {
    margin-bottom: 20px;
  }
}

textarea {
  display: grid;
  grid-template-columns: 1fr max-content;
  gap: 0 10px;
  margin: 0 0 10px;
  line-height: 20px;
  color: $text-black;

  &::placeholder {
    color: $unactive-grey;
    opacity: 1;
  }
}

:deep(.v-field) {
  font-size: 14px;
  font-weight: 600;
  box-shadow: none;
}

:deep(.v-field__input) {
  padding: 0 !important;
  mask-image: none !important;
}

:deep(.v-field__field) {
  padding: 12px;
  background-color: $button-background;
  border-radius: 8px;
  box-shadow: none;
}

:deep(.v-input__details) {
  font-weight: 600;
}
</style>
